import React from "react";

export const FilesIcon: React.FC<any> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    {...props}
  >
    <defs>
      <clipPath id="master_svg0_19_08672/12_21307/12_21296">
        <rect x="0" y="0" width="40" height="40" rx="0" />
      </clipPath>
    </defs>
    <g clipPath="url(#master_svg0_19_08672/12_21307/12_21296)">
      <g>
        <path
          d="M4.000244140625,34C4.000244140625,37.3137,6.686534140625,40,10.000244140625,40L30.000244140625,40C33.313944140625,40,36.000244140625,37.3137,36.000244140625,34L36.000244140625,10L26.000244140625,0L10.000244140625,0C6.686534140625,0,4.000244140625,2.68629,4.000244140625,6L4.000244140625,34Z"
          fill="#FFAB19"
          fillOpacity="1"
        />
      </g>
      <g>
        <path
          d="M24.9095,14.088725L16.98697,16.51674C16.00081,16.82783,15.31048,17.71725,15.253779999999999,18.74975L15.253779999999999,27.0989C14.678049999999999,26.8188,14.0231,26.7467,13.40021,26.8948C11.51989,27.1637,10,28.599800000000002,10,30.1098C10,31.6198,11.51989,32.547,13.40091,32.278099999999995C15.28193,32.009100000000004,16.65328,30.6195,16.65328,29.1102L16.65328,21.047530000000002Q16.65328,20.38016,17.45933,20.09294L24.461100000000002,17.89724Q25.2397,17.63747,25.2397,18.351300000000002L25.2397,25.0046C24.6159,24.723100000000002,23.9226,24.6327,23.2474,24.744799999999998C21.3664,24.976399999999998,19.846519999999998,26.3851,19.846519999999998,27.8951C19.846519999999998,29.405099999999997,21.3664,30.359,23.2474,30.1373C25.128500000000003,29.9155,26.6483,28.497,26.6483,26.987000000000002L26.6483,15.321390000000001C26.6803,14.404943,25.7637,13.755174,24.9095,14.088725Z"
          fill="#FFFFFF"
          fillOpacity="1"
        />
      </g>
      <g>
        <path
          d="M25.999755859375,6C25.999755859375,8.20914,27.790615859375,10,29.999755859375,10L35.999755859375,10L25.999755859375,0L25.999755859375,6Z"
          fill="#FFFFFF"
          fillOpacity="0.4000000059604645"
        />
      </g>
    </g>
  </svg>
);
